// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2260":"e5bb6813","7001":"48fa813a","8849":"48fa813a"}[chunkId] + ".chunk.css";
};